import { Divider as MuiDivider } from '@mui/material';
import type { DividerProps as MuiDividerProps } from '@mui/material/Divider';

export type DividerProps = MuiDividerProps;

export const Divider = ({ ...rest }: DividerProps): JSX.Element => <MuiDivider {...rest} />;
